import { RouterProvider } from "react-router";

import { router } from '../pages/routes';
import './styles.css';
import '../shared/i18n';

function App() {
  return (
    <RouterProvider router={router} />
  )
}

export default App
